import {
  SET_ACTIVE_NAVBAR_ELEMENT
} from './const';

export const setActiveElement = (name) => {
  return {
    type: SET_ACTIVE_NAVBAR_ELEMENT,
    payload: name
  }
};